var root = require('./_root');

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;



//////////////////
// WEBPACK FOOTER
// ./~/react-css-modules/~/lodash/_Uint8Array.js
// module id = 5816
// module chunks = 1